<template>
  <Dialog
    :visible="visible"
    @update:visible="$emit('update:visible', $event)"
    modal
    :closable="!busy"
    style="width: 480px; max-width: 95vw"
  >
    <template #header>
      <h3 style="margin: 0">Liga zuweisen</h3>
    </template>
    <div v-if="team" style="margin-bottom: 12px">
      Mannschaft: <strong>{{ team.name || team.representation }}</strong>
    </div>
    <h4 style="color: red" v-if="error && error.length > 0">{{ error }}</h4>
    <div class="field grid">
      <label class="col-fixed" style="width: 100px">Saison</label>
      <div class="col">
        <Dropdown
          v-model="selectedSeason"
          :options="seasons"
          optionLabel="representation"
          dataKey="id"
          placeholder="Saison auswählen"
          :filter="true"
          style="width: 100%"
          @change="onSeasonChanged"
        />
      </div>
    </div>
    <div class="field grid">
      <label class="col-fixed" style="width: 100px">Liga</label>
      <div class="col">
        <Dropdown
          v-model="selectedLeague"
          :options="availableLeagues"
          optionLabel="representation"
          dataKey="id"
          placeholder="Liga auswählen"
          :filter="true"
          :disabled="!selectedSeason || availableLeagues.length === 0"
          style="width: 100%"
        />
        <small v-if="selectedSeason && availableLeagues.length === 0">
          Die Mannschaft ist bereits in allen Ligen dieser Saison.
        </small>
      </div>
    </div>
    <template #footer>
      <Button
        label="Abbrechen"
        severity="secondary"
        icon="pi pi-times"
        :disabled="busy"
        @click="$emit('update:visible', false)"
      />
      <Button
        label="Zuweisen"
        icon="pi pi-check"
        :disabled="!selectedLeague || busy"
        :loading="busy"
        @click="assign"
      />
    </template>
  </Dialog>
</template>

<script>
import ServerConnection from "../../services/ServerConnection/ServerConnection";
import Dialog from "primevue/dialog";
import Dropdown from "primevue/dropdown";
import Button from "primevue/button";

export default {
  name: "AssignLeagueDialog",
  components: { Dialog, Dropdown, Button },
  props: {
    visible: { type: Boolean, default: false },
    team: { type: Object, default: null },
  },
  emits: ["update:visible", "assigned"],
  data() {
    return {
      seasons: [],
      selectedSeason: null,
      selectedLeague: null,
      busy: false,
      error: "",
    };
  },
  computed: {
    teamLeagueIds() {
      if (!this.team || !Array.isArray(this.team.leagues)) {
        return [];
      }
      return this.team.leagues.map((l) => l.id);
    },
    availableLeagues() {
      if (!this.selectedSeason || !Array.isArray(this.selectedSeason.leagues)) {
        return [];
      }
      return this.selectedSeason.leagues
        .filter((l) => !this.teamLeagueIds.includes(l.id))
        .slice()
        .sort((a, b) =>
          (a.representation || a.name || "").localeCompare(
            b.representation || b.name || ""
          )
        );
    },
  },
  watch: {
    visible(value) {
      if (value) {
        this.openDialog();
      }
    },
  },
  methods: {
    openDialog() {
      this.error = "";
      this.selectedLeague = null;
      this.busy = false;
      this.loadSeasons();
    },
    loadSeasons() {
      ServerConnection.get("data/season")
        .then((response) => {
          var list = Array.isArray(response.data) ? response.data : [];
          list.sort((a, b) =>
            (a.representation || a.name || "").localeCompare(
              b.representation || b.name || ""
            )
          );
          this.seasons = list;
          var current = list.find((s) => s.currentSeason === true);
          this.selectedSeason = current || list[0] || null;
        })
        .catch((err) => {
          this.error = "Konnte Saisons nicht laden: " + this.errorMessage(err);
        });
    },
    onSeasonChanged() {
      this.selectedLeague = null;
    },
    assign() {
      if (!this.selectedLeague || !this.team || !this.team.id) {
        return;
      }
      this.error = "";
      this.busy = true;
      var leagueId = this.selectedLeague.id;
      var teamId = this.team.id;
      ServerConnection.get("data/league/" + leagueId)
        .then((response) => {
          var league = response.data;
          var teams = Array.isArray(league.teams) ? league.teams.slice() : [];
          if (!teams.some((t) => t.id === teamId)) {
            teams.push({ id: teamId });
          }
          league.teams = teams;
          return ServerConnection.put(
            "data/league/" + leagueId,
            JSON.stringify(league)
          );
        })
        .then(() => {
          this.busy = false;
          this.$emit("assigned", this.selectedLeague);
          this.$emit("update:visible", false);
        })
        .catch((err) => {
          this.busy = false;
          this.error = "Zuweisen fehlgeschlagen: " + this.errorMessage(err);
        });
    },
    errorMessage(err) {
      if (err && err.response && err.response.data) {
        return typeof err.response.data === "string"
          ? err.response.data
          : JSON.stringify(err.response.data);
      }
      if (err && err.message) {
        return err.message;
      }
      return "Unbekannter Fehler";
    },
  },
};
</script>
